<template>
  <div class="content">
    <div v-if="pay_type == 'pay'">
      <pay v-if="pay_order.id" :payOrder="pay_order" :openid="openid"></pay>
    </div>
    <div v-if="pay_type == 'studentPay'">
      <student-pay
        :studentId="student_id"
        :softSn="soft_sn"
        :openid="openid"
      ></student-pay>
    </div>
    <div v-if="pay_type == 'flashSale'">
      <flash-sale-pay
        v-if="pay_order.id"
        :payOrder="pay_order"
        :openid="openid"
      ></flash-sale-pay>
    </div>
    <div v-if="pay_type == 'timeline'">
      <timeline-pay :payOrder="pay_order" :openid="openid"></timeline-pay>
    </div>
    <div v-if="pay_type == 'component'">
      <component-pay :payOrder="pay_order" :openid="openid"></component-pay>
    </div>
    <div v-if="pay_type == 'insure' || pay_type == 'insureOrder'">
      <insure-pay :openid="openid" :pay_type="pay_type"></insure-pay>
    </div>
    <div v-if="pay_type == 'ecSale'">
      <ec-sale-pay :payOrder="pay_order" :openid="openid"></ec-sale-pay>
    </div>
    <div v-if="pay_type == 'school'">
      <school-pay :payOrder="pay_order" :openid="openid"></school-pay>
    </div>
    <div v-if="pay_type == 'common'">
      <common-pay />
    </div>
    <div v-if="pay_type == 'iceOut'">
      <ice-pay />
    </div>
    <div v-if="pay_type == 'simulator'">
      <simulator-pay :openid="openid"></simulator-pay>
    </div>
    <div v-if="pay_type == 'exchange'">
      <exchange-pay :openid="openid"></exchange-pay>
    </div>
    <div v-if="pay_type == 'tiktok'">
      <tiktok-pay :openid="openid"></tiktok-pay>
    </div>
    <div v-if="pay_type == 'sale'">
      <sale-pay :openid="openid"></sale-pay>
    </div>
    <div v-if="pay_type == 'miniPay'">
      <mini-pay :studentId="student_id" :softSn="soft_sn" :openid="openid"></mini-pay>
    </div>
  </div>
</template>
<script>
import URL from "../../../static/js/url.js";
import _wx from "../../../static/js/chelun-wx-1.1.js";
import _kjz from "../../../static/js/chelun-kjz.js";
import flashSalePay from "../../components/flashSalePay";
import studentPay from "../../components/studentPay";
import timelinePay from "../../components/timeline";
import componentPay from "../../components/component";
import insurePay from "../../components/insurePay";
import ecSalePay from "../../components/ecSalePay";
import schoolPay from "../../components/schoolPay";
import pay from "../../components/pay";
import CommonPay from "../../components/common-pay";
import IcePay from "../../components/ice-out.vue"; // 冻结解冻H5支付
import simulatorPay from "../../components/simulator-pay.vue";
import exchangePay from "../../components/exchange-pay.vue";
import tiktokPay from "../../components/tiktok-pay.vue";
import salePay from "../../components/sale-pay.vue";
import miniPay from "../../components/miniPay.vue";

export default {
  data() {
    return {
      openid: URL.getQueryString("openid") || "",
      query: URL.getQueryString("query") || "",
      student_id: "",
      soft_sn: "",
      pay_order: {},
      pay_type: "",
    };
  },
  methods: {},
  created() {
    this.pay_type = sessionStorage.pay_type || URL.getQueryString("pay_type");
    console.log(this.pay_type, '=========>>>>>pay_type1')
    if (this.query) {
      this.pay_type = JSON.parse(decodeURIComponent(this.query)).pay_type;
      sessionStorage.setItem("query", decodeURIComponent(this.query));
      sessionStorage.setItem("pay_type", this.pay_type);
    }
    if(this.pay_type === 'miniPay') {
      sessionStorage.setItem("student_id", URL.getQueryString('student_id'));
      sessionStorage.setItem("soft_sn", URL.getQueryString('soft_sn'));
      console.log(URL.getQueryString('student_id'), '===========>>URL.getQueryString.student_id')
      console.log(URL.getQueryString('soft_sn'), '===========>>URL.getQueryString.soft_sn')
    }
    window["CHELUN_SHOW_OPTION_MENU"] = 0;
    _wx.hideMenus([
      "menuItem:share:appMessage",
      "menuItem:share:timeline",
      "menuItem:share:qq",
      "menuItem:share:weiboApp",
      "menuItem:favorite",
      "menuItem:share:facebook",
      "menuItem:share:QZone",
    ]);
  },
  mounted() {
    this.student_id = sessionStorage.student_id;
    this.soft_sn = sessionStorage.soft_sn;
    this.created_at = sessionStorage.created_at;
    console.log(this.student_id, this.soft_sn, '=========>>>>>1')
    console.log(this.pay_type, '=========>>>>>pay_type')
    this.pay_order = sessionStorage.pay ? JSON.parse(sessionStorage.pay) : {};
    if (this.pay_type == "insure") {
      document.title = "购买拿本无忧保障";
    }
  },
  components: {
    "flash-sale-pay": flashSalePay,
    "student-pay": studentPay,
    pay: pay,
    "timeline-pay": timelinePay,
    "component-pay": componentPay,
    "insure-pay": insurePay,
    "ec-sale-pay": ecSalePay,
    "school-pay": schoolPay,
    "common-pay": CommonPay,
    "ice-pay": IcePay,
    "simulator-pay": simulatorPay,
    "exchange-pay": exchangePay,
    "tiktok-pay": tiktokPay,
    "sale-pay": salePay,
    "mini-pay": miniPay
  },
};
</script>

<style lang="scss" scoped>
.content {
  font-size: 0;
  color: #333;
}
</style>



// WEBPACK FOOTER //
// src/pages/pay/Pay.vue